import { useEffect } from 'react';

/**
 * Imposta il titolo del documento: fondamentale per screen reader
 * e navigazione tra schede. Formato: "Pagina — PandaCalcio".
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} — PandaCalcio` : 'PandaCalcio';
  }, [title]);
}
